import React, {
    createContext,
    useReducer,
    useContext,
    useCallback,
} from 'react';
import { globalReducer, initialState } from './reducer';
import type { DispatchAction } from './types';

export const StateContext = createContext(initialState);
export const DispatchContext = createContext<React.Dispatch<any>>(() => {});

const StateProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [state, dispatch] = useReducer(globalReducer, initialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
};

const useGlobalState = () => useContext(StateContext);
const useGlobalDispatch = () => {
    const dispatch = useContext(DispatchContext);

    return useCallback(
        (action: DispatchAction) => {
            if (typeof action === 'function') {
                return action(dispatch);
            }
            return dispatch(action);
        },
        [dispatch]
    );
};

export { 
    StateProvider as SecondIFrameStateProvider,
    useGlobalDispatch as useSecondIFrameDispatch,
    useGlobalState as useSecondIFrameState,
 };
